import { UploadMultiFileProps } from 'components/ui/forms/utilComponents/upload/UploadMultiFile';
import UploadSingleFile from 'components/ui/forms/utilComponents/upload/UploadSingleFile';
import { FormikContextType } from 'formik';
import React from 'react';
import FileUtils from 'utils/File';

interface IProps {
  fieldName: string;
  label?: string;
  disabled?: boolean;
  formState: FormikContextType<any>;
  additionalProps?: Partial<UploadMultiFileProps>;
}

function UploadSingleFileMemorized({
  fieldName,
  label,
  formState: { setFieldValue, values, touched, errors },
  ...additionalProps
}: IProps) {
  const handleDropFile = (acceptedFiles: any) => setFieldValue(fieldName, acceptedFiles.map(FileUtils.prepareNewFileForUploader)[0]);

  return (
    <UploadSingleFile
      file={values[fieldName]}
      onDrop={handleDropFile}
      maxSize={5242880}
      error={Boolean(touched[fieldName] && errors[fieldName])}
      {...additionalProps}
    />
  );
}

export default React.memo(
  UploadSingleFileMemorized,
  (prevProps, nextProps) =>
    prevProps.formState.values[prevProps.fieldName]?.size === nextProps.formState.values[nextProps.fieldName]?.size &&
    prevProps.disabled === nextProps.disabled
  // && prevProps.error === nextProps.error
);
